import React from 'react';

import styles from './LoadingSpinner.module.scss';
import { ReactComponent as LogoLoader } from './../../assets/logo.svg';

type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZE_MAP: Record<SpinnerSize, string> = {
  sm: '24px',
  md: '48px',
  lg: '80px',
};

export function LoadingSpinner({ size = 'lg' }: { size?: SpinnerSize }): React.JSX.Element {
  return (
    <div className={styles.spinnerContainer}>
      <LogoLoader className={styles.rotatingCoin} style={{ width: SIZE_MAP[size], height: SIZE_MAP[size] }} />
    </div>
  );
}
